
import { navigateTo } from './navigation';
import { endSession, goToLogin } from './session';
import { isCafeteriaMode } from './appMode';

var config = process.env;

export function validateSession(dontCheckCashRegister=false)
{
    var request = {
        method: 'POST',
        headers: { 
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }
    };
    return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'session/checkSessionAdmin', request)
    .then(results => { return results.json(); })
    .then(data => {
        if (data.error == 0 && data.data.isValidToken) {
            localStorage.setItem('role', String(data.data.role));

            if (hasPermissions(data.data.role))
            {
                if(dontCheckCashRegister)
                {
                    return data.data.role
                }                
                else
                {
                    if(data.data.role != 1)
                    {
                        checkCashRegisterClosure()
                        return data.data.role
                    }
                    else 
                    {
                        return data.data.role
                    }
                } 
            } 
            else
            {
                // El rol es válido, sólo que esta pantalla no es para él: se lo saca de acá
                // pero NO se le cierra la sesión.
                goToLogin();
            }
        } else {
            // Token vencido o inválido: se limpia y se sale al login. Antes esto navegaba a
            // REACT_APP_REDIRECT_LOGIN (en local, un puerto muerto) y dejaba el token roto
            // en el localStorage, así que al volver se caía otra vez en lo mismo.
            endSession();
        }
    });
}

function hasPermissions(role)
{
    let result = true
    if (role === 4)
    {
        let url = new URL(window.location.href);
        let lastPart = url.pathname.split('/').pop();
        // Finanzas sólo entra a Facturas, en sus dos pestañas (emitidas y recibidas).
        if(lastPart != "invoices" && lastPart != "receivedInvoices")
            result = false
    }
    return result
}

export async function getCashRegister() {
    // Mientras se corrige la validación de caja, cafetería no debe quedar bloqueada ni
    // redirigida a /caja. El resto del backoffice conserva la consulta real.
    if (isCafeteriaMode()) {
        return { error: 0, data: { status: 1 } };
    }

    var request = {
        method: 'GET',
        headers: { 
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }
    };

    try {
        const response = await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'session/checkCashRegister', request);
        const data = await response.json();
        if (data && data.error === 0 && data.data && data.data.status !== undefined) {
            sessionStorage.setItem('cashRegisterStatus', String(data.data.status));
        }
        return data;
    } catch (error) {
        console.error('Error al obtener el estado de la caja:', error);
        throw error;
    }
}

export async function checkCashRegisterClosure() {
    try {
        let data = await getCashRegister();
        console.log(data);
        if (data.error === 0 && data.data.status === 0) {
            navigateTo('/caja');
        }
    } catch (error) {
        console.error('Error al verificar el estado de la caja:', error);
    }
}

export async function getProviders(providerType){
    var request = {
        method: 'GET',
        headers: { 
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }
    };
    try {
        return await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider/' + providerType, request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return []
            } else {
               return data.data
            }
        });
    } catch (error) {
        console.error(`No se pudieron cargar los proveedores de tipo ${providerType}:`, error);
        return [];
    }
}

export function formatNumber(num) {
    if (num === '') return '';
    const parsedNumber = parseFloat(num.replace(/\./g, ''));
    if (isNaN(parsedNumber)) return '';
    return `$${parsedNumber.toLocaleString('de-DE')}`;
};
